import { mkdirSync, rmdirSync } from "fs";
import { getPackageDirectoryName } from "./getPackageDirectoryName";

export function createPackageDirectory() {
    rmdirSync(`./${getPackageDirectoryName()}`, { recursive: true });
    mkdirSync(`./${getPackageDirectoryName()}`);
}